import { isNil } from 'lodash-es';
import { BM } from '../common/types';
import { GqlCompanyDirector } from '../graphql/base-types.graphql';

export function defaultSignatory<T extends Pick<GqlCompanyDirector, 'functions'>>(
  cds: T[],
  boardOnly = false,
): T | undefined {
  if (!boardOnly) {
    const ceo = cds.find(cd => cd.functions.findIndex(f => f.code === BM.Vd || f.code === BM.Evd) >= 0);
    if (!isNil(ceo)) {
      return ceo;
    }
  }
  const chairman = cds.find(cd => cd.functions.findIndex(f => f.code === BM.Of) >= 0);
  if (!isNil(chairman)) {
    return chairman;
  }
  const boardMembers = cds.filter(cd => cd.functions.findIndex(f => f.code === BM.Le) >= 0);
  if (boardMembers.length > 1) {
    return boardMembers[0];
  }
}
